"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Quote = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledSystem = require("styled-system");

var _Theme = require("../../Theme/Theme.media");

var _Theme2 = require("../../Theme/Theme.spacing");

var _Theme3 = require("../../Theme/Theme.variables");

var _Box = require("../Box/Box");

var _Text = require("../Text/Text");

var _Case = _interopRequireDefault(require("../Case/Case"));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject20() {
  var data = _taggedTemplateLiteral(["\n      color: ", ";\n    "]);

  _templateObject20 = function _templateObject20() {
    return data;
  };

  return data;
}

function _templateObject19() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  position: relative;\n  text-transform: uppercase;\n  font-family: ", ";\n  line-height: ", ";\n  ", ";\n\n  ", " ", ";\n"]);

  _templateObject19 = function _templateObject19() {
    return data;
  };

  return data;
}

function _templateObject18() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject18 = function _templateObject18() {
    return data;
  };

  return data;
}

function _templateObject17() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject17 = function _templateObject17() {
    return data;
  };

  return data;
}

function _templateObject16() {
  var data = _taggedTemplateLiteral(["\n    width: ", "px;\n    height: 1px;\n    position: absolute;\n    left: -", "px;\n    background-color: ", ";\n  "]);

  _templateObject16 = function _templateObject16() {
    return data;
  };

  return data;
}

function _templateObject15() {
  var data = _taggedTemplateLiteral(["\n  font-style: normal;\n"]);

  _templateObject15 = function _templateObject15() {
    return data;
  };

  return data;
}

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n    font-weight: normal;\n  "]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n    font-weight: ", ";\n  "]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    color: ", ";\n    ", ";\n\n    &:before {\n      content: '\\201C';\n      font-weight: ", ";\n      color: ", ";\n      display: block;\n      font-size: 3em;\n      line-height: 1;\n    }\n  "], ["\n    font-family: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    color: ", ";\n    ", ";\n\n    &:before {\n      content: '\\\\201C';\n      font-weight: ", ";\n      color: ", ";\n      display: block;\n      font-size: 3em;\n      line-height: 1;\n    }\n  "]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n    font-family: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    ", ";\n\n    &:before {\n      content: '\\201C';\n      font-weight: ", ";\n    }\n\n    &:after {\n      content: '\\201D';\n      font-weight: ", ";\n    }\n  "], ["\n    font-family: ", ";\n    font-weight: ", ";\n    line-height: ", ";\n    ", ";\n\n    &:before {\n      content: '\\\\201C';\n      font-weight: ", ";\n    }\n\n    &:after {\n      content: '\\\\201D';\n      font-weight: ", ";\n    }\n  "]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  padding: unset;\n  margin: unset;\n  border: unset;\n  font-size: unset;\n  ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n    border-left-width: 1px;\n    border-left-style: solid;\n    border-left-color: ", ";\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["font-size: ", "px;"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["font-size: ", "px;"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["font-size: ", "px;"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["font-size: ", "px;"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-size: ", "px;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var sizing = (0, _styledComponents.css)(_templateObject(), function (props) {
  return (0, _Theme3.variables)(props).headerSizes.default[props.size] * (props.headline ? (0, _Theme3.variables)(props).headlineModifier : 1);
}, function (props) {
  return _Theme.media.sm(_templateObject2(), (0, _Theme3.variables)(props).headerSizes.sm[props.size] * (props.headline ? (0, _Theme3.variables)(props).headlineModifier : 1));
}, function (props) {
  return _Theme.media.md(_templateObject3(), (0, _Theme3.variables)(props).headerSizes.md[props.size] * (props.headline ? (0, _Theme3.variables)(props).headlineModifier : 1));
}, function (props) {
  return _Theme.media.lg(_templateObject4(), (0, _Theme3.variables)(props).headerSizes.lg[props.size] * (props.headline ? (0, _Theme3.variables)(props).headlineModifier : 1));
}, function (props) {
  return _Theme.media.xl(_templateObject5(), (0, _Theme3.variables)(props).headerSizes.xl[props.size] * (props.headline ? (0, _Theme3.variables)(props).headlineModifier : 1));
});
var quoteWrapper = {
  gentux: (0, _styledComponents.css)(_templateObject6(), function (props) {
    return "".concat((0, _Theme3.variables)(props)['grayDark']);
  }),
  menguin: (0, _styledComponents.css)(_templateObject7())
};
var QuoteWrapper = (0, _styledComponents.default)(_Box.Box)(_templateObject8(), function (props) {
  return quoteWrapper[props.theme.brand];
});

var Blockquote = _styledComponents.default.blockquote(_templateObject9(), _styledSystem.space);

var quoteText = {
  gentux: (0, _styledComponents.css)(_templateObject10(), function (props) {
    return (0, _Theme3.variables)(props).fontHeadline;
  }, function (props) {
    return (0, _Theme3.variables)(props).fontHeadlineWeight;
  }, function (props) {
    return (0, _Theme3.variables)(props).lineHeight[props.size];
  }, sizing, function (props) {
    return (0, _Theme3.variables)(props).fontHeadlineWeight;
  }, function (props) {
    return (0, _Theme3.variables)(props).fontHeadlineWeight;
  }),
  menguin: (0, _styledComponents.css)(_templateObject11(), function (props) {
    return (0, _Theme3.variables)(props).fontHeadline;
  }, function (props) {
    return (0, _Theme3.variables)(props).fontHeadlineWeight;
  }, function (props) {
    return (0, _Theme3.variables)(props).lineHeight[props.size];
  }, function (props) {
    return (0, _Theme3.variables)(props).grayDarker;
  }, sizing, function (props) {
    return (0, _Theme3.variables)(props).fontHeadlineWeight;
  }, function (props) {
    return (0, _Theme3.variables)(props).primary;
  })
};

var QuoteText = _styledComponents.default.q(_templateObject12(), function (props) {
  return quoteText[props.theme.brand];
});

var citationName = {
  gentux: (0, _styledComponents.css)(_templateObject13(), function (props) {
    return (0, _Theme3.variables)(props).fontWeight;
  }),
  menguin: (0, _styledComponents.css)(_templateObject14())
};

var Citation = _styledComponents.default.cite(_templateObject15());

var citationDash = {
  gentux: (0, _styledComponents.css)(_templateObject16(), function (props) {
    return _Theme2.sizeToPx[4];
  }, function (props) {
    return _Theme2.sizeToPx[4] + _Theme2.sizeToPx[3];
  }, function (props) {
    return (0, _Theme3.variables)(props)['grayDark'];
  }),
  menguin: (0, _styledComponents.css)(_templateObject17())
};
var CitationDash = (0, _styledComponents.default)(_Box.Box)(_templateObject18(), function (props) {
  return citationDash[props.theme.brand];
});

var CitationName = _styledComponents.default.div(_templateObject19(), function (props) {
  return (0, _Theme3.variables)(props).fontHeader;
}, function (props) {
  return (0, _Theme3.variables)(props).lineHeight[props.size];
}, function (props) {
  return props.textColor && (0, _styledComponents.css)(_templateObject20(), (0, _Theme3.variables)(props)[props.textColor]);
}, function (props) {
  return citationName[props.theme.brand];
}, sizing);

var Quote = function Quote(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  var citationName = props.citationName,
      citationTitle = props.citationTitle;
  return _react.default.createElement(Blockquote, props, _react.default.createElement(QuoteWrapper, {
    mb: 3,
    pl: 4
  }, _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_Case.default, {
    brand: "gentux"
  }, _react.default.createElement(QuoteText, {
    size: 2
  }, children)), _react.default.createElement(_Case.default, {
    brand: "menguin"
  }, _react.default.createElement(QuoteText, {
    size: 4
  }, children)))), citationName && _react.default.createElement(Citation, null, _react.default.createElement(_Box.Box, {
    display: "flex",
    justifyContent: "flex-end"
  }, _react.default.createElement(_Box.Box, {
    display: "block"
  }, _react.default.createElement(_Case.default, {
    brand: "gentux"
  }, _react.default.createElement(CitationName, {
    size: 4,
    textColor: "grayDark"
  }, _react.default.createElement(CitationDash, null), citationName)), _react.default.createElement(_Case.default, {
    brand: "menguin"
  }, _react.default.createElement(CitationName, {
    size: 6,
    textColor: "grayDark"
  }, _react.default.createElement(CitationDash, null), citationName)), citationTitle && _react.default.createElement(_Text.Text, {
    textColor: "gray",
    small: true
  }, citationTitle)))));
};

exports.Quote = Quote;
Quote.displayName = 'Quote'; // Prop Types

Quote.propTypes = {
  citationName: _propTypes.default.string,
  citationTitle: _propTypes.default.string
};
Quote.defaultProps = {};